<div class="tw-relative tw-font-['Rubik']">
  <div class="tw-w-full tw-text-center tw-py-4 tw-bg-[#ff6f5b] tw-relative tw-grid tw-place-content-center">
    <span *ngIf="isWarning" class="tw-font-semibold tw-text-lg tw-text-white">{{'notifications.payment_warning.title' | translate}}</span>
    <span *ngIf="isSuspension" class="tw-font-semibold tw-text-lg tw-text-white">{{'notifications.payment_none.title' | translate}}</span>
    <div class="tw-absolute tw-w-[16px] tw-h-[16px] tw-inset-y-0 tw-my-auto tw-right-4 tw-grid tw-place-content-center" *ngIf="data?.type?.alert_property_type?.name !== 'blocking'">
      <button class="focus:tw-outline-0" (click)="handleClose()">
        <i class="fas fa-times tw-text-xl tw-text-white"></i>
      </button>
    </div>
  </div>
  <div class="tw-py-6 tw-px-8 md:tw-px-12 tw-flex tw-flex-col">
    <section *ngIf="isWarning" class="tw-flex tw-flex-col tw-gap-4" [innerHTML]="'notifications.payment_warning.message' | translate: {name}">
    </section>
    <section *ngIf="isSuspension" class="tw-flex tw-flex-col tw-gap-4" [innerHTML]="'notifications.payment_none.message' | translate: {name}">
    </section>
    <section>
      <ng-container *ngIf="isWarning">
        <ng-container *ngTemplateOutlet="warning"></ng-container>
      </ng-container>
      <ng-container *ngIf="isSuspension">
        <ng-container *ngTemplateOutlet="suspension"></ng-container>
      </ng-container>
    </section>
  </div>
</div>

<ng-template #warning>
  <div class="tw-flex tw-flex-col sm:tw-flex-row tw-justify-center tw-mt-8 tw-gap-4">
    <mh-core-lib-button
      [isSecondary]="true"
      [text]="'configuration.invoice.go_to_invoice' | translate"
      [width]="285"
      [height]="38"
      customClass="!tw-rounded-full !tw-font-[Rubik]"
      (clicked)="handleInvoiceRedirect()">
    </mh-core-lib-button>
    <mh-core-lib-button
      [isPrimary]="true"
      [text]="'notifications.payment_warning.subscribe_automatic_payment' | translate"
      [width]="285"
      [height]="38"
      customClass="!tw-rounded-full !tw-font-[Rubik]"
      (clicked)="handleSubscribeAutomaticPayment()">
    </mh-core-lib-button>
  </div>
</ng-template>

<ng-template #suspension>
  <div class="tw-flex tw-flex-col sm:tw-flex-row tw-justify-center tw-mt-8 tw-gap-4">
    <mh-core-lib-button
      [isSecondary]="true"
      [text]="'configuration.invoice.go_to_invoice' | translate"
      [width]="285"
      [height]="38"
      customClass="!tw-rounded-full !tw-font-[Rubik]"
      (clicked)="handleInvoiceRedirect()">
    </mh-core-lib-button>
    <mh-core-lib-button
      [isPrimary]="true"
      [text]="'notifications.payment_none.subscribe_automatic_payment' | translate"
      [width]="285"
      [height]="38"
      customClass="!tw-rounded-full !tw-font-[Rubik]"
      (clicked)="handleSubscribeAutomaticPayment()">
    </mh-core-lib-button>
  </div>
</ng-template>
